export default __webpack_public_path__ + "static/stars-59c5fcf28e451a253ae5158bd075a97e.svg";